{
  "EMOJI": {
    "PLACEHOLDER": "جستجوی اموجی",
    "NOT_FOUND": "هیچ اموجی با جستجوی شما مطابقت ندارد",
    "REMOVE": "حذف"
  }
}
